(function() {
  'use strict';

  angular.module('app').factory('StatusService', StatusService);

  function StatusService(WebApiService) {
    return {
      getStatusList: function() {
        return WebApiService.get('/api/Status/GetStatusList');
      },

      getAvailableStatusList: function(currentStatusId) {
        return WebApiService.get('/api/Status/GetAvailableStatusList', { currentStatusId: currentStatusId });
      },

      isRecordDeleted: function(projectLevelId, projectId) {
        return WebApiService.get('/api/Status/IsRecordDeleted', {
          ProjectLevelId: projectLevelId,
          ProjectId: projectId
        });
      }
    };
  }
})();
